import { Injectable } from "@angular/core";
import { Validators } from "@angular/forms";
import { Observable, of } from "rxjs";
import { QuestionBase } from "../../../../shared/components/dynamic-form/question-base";
import { DropdownQuestion } from "../../../../shared/components/dynamic-form/question-dropdown";
import { TextboxQuestion } from "../../../../shared/components/dynamic-form/question-textbox";
import { configurableOptionsTypes } from "../configurable-options";
import { ConfigurableOptionTypes } from "../configurable-options.type";

export interface ICreateConfigurableOptionForm {
  value: string;
  type: ConfigurableOptionTypes;
}

@Injectable()
export class CreateConfigurableOptionService {
  constructor() {}

  generateQuestions(options?: {
    value?: string;
    type?: ConfigurableOptionTypes;
  }): Observable<QuestionBase<string | boolean>[]> {
    const questions: QuestionBase<string | boolean>[] = [
      new DropdownQuestion({
        key: "type",
        label: "Type",
        value: options.type,
        required: true,
        options: configurableOptionsTypes,
        order: 1,
      }),

      new TextboxQuestion({
        key: "value",
        label: "Value",
        value: options.value,
        required: true,
        order: 2,
        errors: [
          {
            key: "minlength",
            validator: Validators.minLength(1),
            message: "Value is <strong>too short</strong>",
          },
          {
            key: "maxlength",
            validator: Validators.maxLength(255),
            message: "Value is <strong>too long</strong>",
          },
        ],
      }),
    ];

    return of(questions.filter((field) => field).sort((a, b) => a.order - b.order));
  }
}
